<template>
  <el-table :data="tableData" border style="width: 100%" :maxHeight="maxHeight">
    <template slot="empty">
      <empty />
    </template>
    <el-table-column sortable prop="className" label="线级城市" width="150px">
    </el-table-column>
    <el-table-column
      sortable
      prop="payCustomerCount"
      label="付款人数"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="payTradeCount"
      label="付款订单笔数"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="payItemCount"
      label="付款商品件数"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="successPayment"
      label="付款金额"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="payAvgRate"
      label="付款客单价"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="tradeCountAvgRate"
      label="付款客单量"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="itemCountAvgRate"
      label="付款客单件"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="itemPerPriceAvgRate"
      label="付款件单价"
      width="150px"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="reBuyCustomerCount"
      label="复购人数"
      width="150px"
    >
    </el-table-column>
    <el-table-column sortable prop="reBuyRate" label="复购率" width="150px">
      <template slot-scope="scope">{{ scope.row.reBuyRate }}%</template>
    </el-table-column>
  </el-table>
</template>

<script>
import Empty from "../components/empty.vue";
export default {
  name: "tiercity_analysis",
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
};
</script>
